// @flow

import Request from '@insolus/request';
import type { RequestPromise } from '@insolus/request';
import type { Icon } from 'components/CategoryIcon';
import type {
    AllPaginateParams,
    PaginatedResult,
    Translations,
    SeoFields,
    SeoFieldTranslations
} from 'stores/api/_types';

type Params = {
    ...AllPaginateParams,
    parentId?: number
};

type CategoryBase = {|
    parentId: number | null,
    name: string,
    icon: Icon | null,
    lft: number,
    rght: number,
    level: number,
    childrenCount: number
|};

export type CategoryItem = {|
    id: number,
    ...CategoryBase
|};

export type Category = {|
    id: number,
    ...CategoryBase,
    nameTranslation: Translations,
    ...SeoFields,
    ...SeoFieldTranslations
|};

export type CategoryFormData = {
    parentId: number | null,
    name: Translations
};

// ------------------------------------------------------
// -
// -    Functions
// -
// ------------------------------------------------------

const all = (
    parentId?: number, _params?: AllPaginateParams
): RequestPromise<PaginatedResult<CategoryItem[]>> => {
    const params: Params = { ..._params };
    if (parentId) {
        params.parentId = parentId;
    }
    return Request.get(`/categories`, { params });
};

const get = (id: number): RequestPromise<Category> => Request.get(`/categories/${id}`);

const add = (data: CategoryFormData): RequestPromise<Category> => Request.post('/categories', data);

const edit = (id: number, category: CategoryFormData): RequestPromise<Category> => Request.put(`/categories/${id}`, category);

const remove = (id: number): RequestPromise<void> => Request.delete(`/categories/${id}`);

export default { all, get, add, edit, remove };
